import * as d3 from 'd3';

import { LoggerFactory, ILogger } from '../../helpers/helpers';
import { ResizableBase } from './ResizableBase';

export class HorizontalGridLines extends ResizableBase {
    private _logger: ILogger;
    private _isVisible: boolean;
    private _scale: d3.scale.Linear<any, any>;
    private _ticksCount: number;
    private _width: number;
    private _height: number;
    private _originalContainer: d3.Selection<any>;
    constructor(container: d3.Selection<any>, scale: d3.scale.Linear<any, any>, width: number, height: number) {

        super(container, 'horizontal-gridLines');
        try {
            this._logger = LoggerFactory.getLogger('WideTech.Charting.horizontalGridLines', false, 2);
            this.isVisible(true);
            this._ticksCount = 6;
            this._width = width;
            this._height = height;
            this._scale = scale;
            this._originalContainer = container;
        } catch (e) {
            this._logger.error(e);
        }
    }

    isVisible(value?: boolean): boolean {
        if (value !== null && value !== undefined) {
            this._isVisible = value;
            if (this._isVisible) {
                this.group().style({
                    'visibility': 'visible'
                });
            } else {
                this.group().style({
                    'visibility': 'hidden'
                });
            }
        }
        return this._isVisible;
    }

    updateHorizontalGridlines() {
        try {

            if (this.isVisible()) {
                const gridLines = d3.svg.axis()
                    .scale(this._scale)
                    .ticks(this._ticksCount)
                    .orient('left')
                    .tickSize(-this._width, 0)
                    .tickFormat(() => '');
                const selection = this.group();
                gridLines(selection);
                selection
                    .selectAll('line')
                    .classed('gridline', true);
            }
        } catch (e) {
            this._logger.error(e);
        }
    }

    resizeFunction(): (width: number, height: number) => void {
        const self = this;
        return (w, h) => {
            try {
                self._logger.info('Resize horizontal grid lines.');
                self._width = w;
                self._height = h;
                self._scale.range([h, 0]);
                self.updateHorizontalGridlines();
            } catch (e) {
                self._logger.error(e);
            }
        };
    }

    scale(value?: d3.scale.Linear<any, any>): d3.scale.Linear<any, any> {
        if (value) {
            this._scale = value;
        }
        return this._scale;
    }

    move(before: string): void {
        const toMove = this.group().remove();
        //Works but generates an error at compile time	
        (<any>this._originalContainer).insert(() => toMove[0][0], before);
    }

}